import React, { useEffect, useMemo, useState } from 'react';
import Formsy from 'formsy-react';
import { useDispatch, useSelector } from 'react-redux';
import DocumentGallery from '../DocsUpload/DocumentGallery';
import FormsyInputField from '../elements/FormsyInputField';
import FormsySelect from '../../elements/FormsySelect';
import { useOutletContext, useNavigate, useParams } from 'react-router-dom';
import LeadRemarkHistory from '../lead/component/LeadRemarkHistory';
import Modal from '../../elements/Modal';
import { executeGraphQLMutation } from '../../../services/refinance/executeGraphQLQuery';
import { UCRF_UPDATE_CUSTOMER_BASIC_DETAILS } from '../../../services/customer.gql';
import { useApolloClient } from '@apollo/client';
import { toast } from 'react-toastify';
import { getUCRFFormFillStatus, getUCRFLeadDetail, getLeadRemarkUCRF, webDocumentConfig } from '../../../store/action/allAction';
import { CHECK_ASSIGN_USER, IS_USER_ACCESS_PAGE } from '../../../config/constants';
import Loader from '../../elements/Loader';
import { CONTRACT_SIGNED, CUSTOMER_PERSONAL_DETAIL_FILLED, LOST_STATUS, SENT_TO_FINANCIER } from '../../../config/refinance/constant';

const RefinancePersonalDetailsForm = (props) => {
  const [personalDetails, setPersonalDetails] = useState({});
  const [basicDetails, setBasicDetails] = useState({});
  const [allowSubmit, setAllowSubmit] = useState(false);
  const [ViewTimeLine, setViewTimeLine] = useState(false);
  const [showremarkform, setShowremarkform] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isSaveDisable, setIsSaveDisabled] = useState(true)
  const [isRemarkDisable, setIsRemarkDisabled] = useState(true)
  const [isNextEnable, setIsNextEnabled] = useState(false)
  const { master_data_ucrf, leadDetail, remarksHistory } = useSelector(({ lead, masterdataucrf }) => ({
    master_data_ucrf: masterdataucrf?.master_data_ucrf || {},
    lead,
    remarksHistory: lead.remarksHistory || [],
    leadDetail: lead?.ucrfLeadDetail || {},
  }));
  const client = useApolloClient();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  let { lead_id } = useParams();

  const user_information = useSelector((state) => state.user.user_information);
  const UserInfo = JSON.parse(user_information);
  let logged_user_id = (UserInfo && UserInfo.id) ? UserInfo.id : 0;

  const getContext = useOutletContext();
  const documentCategoryList = getContext.docList || []

  useEffect(() => {
    if (leadDetail?.basic_details) {
      if (leadDetail?.personal_details && Object.keys(leadDetail?.personal_details).length) {
        let personalDetails = { ...leadDetail.personal_details };
        setPersonalDetails(personalDetails);
      }
      let basicDetails = { ...leadDetail.basic_details };
      setBasicDetails(basicDetails)
      checkSaveEnable(leadDetail)
    }
    dispatch(getLeadRemarkUCRF({ lead_id: leadDetail.lead_id, source: 'WEB' }, client));
  }, [leadDetail]);


  let ALL_OPTIONS = useMemo(() => {
    let options = master_data_ucrf ? { ...master_data_ucrf } : {};
    return options;
  }, [master_data_ucrf]);

  const handleInputChange = event => {
    if (event.target.name) {
      setPersonalDetails(currentValue => ({
        ...currentValue,
        [event.target.name]: event.target.value
      }))
    }
  }

  const handlePatternFormatChange = (data, field_name) => {
    if (data.value !== undefined && field_name) {
      setPersonalDetails(currentValue => ({
        ...currentValue,
        [field_name]: data.value
      }))
    }
  }

  const handleSelectChange = (data, field_name) => {
    if (data && field_name) {
      setPersonalDetails(currentValue => ({
        ...currentValue,
        [field_name]: data.value
      }))
    }
  }

  const handleSubmit = () => {
    let lead_id = leadDetail?.lead_id || "";

    let reqBody = {
      personal_customer_name: basicDetails.customer_name || "",
      customer_mobile_number: basicDetails.customer_mobile_no || "",
      customer_date_of_birth: basicDetails.date_of_birth || "",
      customer_govt_id: basicDetails.customer_govt_id || "",
      customer_email_id: personalDetails.customer_email_id || "",
      customer_alternative_mobile_no: personalDetails.customer_alternative_mobile_no || "",
      customer_civil_status: personalDetails.customer_civil_status || "",
      customer_type: personalDetails.customer_type || "",
      customer_educational_attainment: personalDetails.customer_educational_attainment || "",
      customer_mother_name: personalDetails.customer_mother_name || "",
      customer_father_name: personalDetails.customer_father_name || "",
      customer_gender: personalDetails.customer_gender || "",
      customer_number_of_dependents: personalDetails.customer_number_of_dependents || "",
    }
    let mutation = UCRF_UPDATE_CUSTOMER_BASIC_DETAILS,
      variables = {
        lead_data: {
          created_by: logged_user_id || 0,
          updated_by: logged_user_id || 0,
          tab_id: 4,
          sub_tab_id: 0,
          lead_id,
          auto_save: 0,
          personal_details: reqBody
        },
      };
    setLoading(true)
    executeGraphQLMutation(mutation, variables, client).then(resp => {
      let response = resp?.data?.updateLeadDetails || null;
      if (response && !response.lead_id) {
        throw new Error(response.error || "Something went wrong");
      }
      toast.success("Success");
      dispatch(getUCRFLeadDetail(lead_id, client))
      dispatch(webDocumentConfig(lead_id, client))
      dispatch(getUCRFFormFillStatus({ lead_id }, client))
      setLoading(false)
      navigateToNext();
    })
      .catch(err => {
        setLoading(false)
        toast.error(err.message);
      })
  }

  const navigateToNext = () => {
    navigate(`/refinance/lead-detail/residential-details/${lead_id}`);
  }

  const showModalViewTimeLine = () => {
    setViewTimeLine(true);
    setShowremarkform(true);
    document.body.classList.add("overflow-hidden");
  };

  const hideModalViewTimeLine = () => {
    setViewTimeLine(false);
    document.body.classList.remove("overflow-hidden");
  };

  const sectionInfo = { section: "Customer details", sub_section: "Personal Details" }

  const checkSaveEnable = (leadDetail) => {
    let markAsFreezed = leadDetail?.customer_timeline_status_ids?.length && leadDetail.customer_timeline_status_ids.findIndex(e => e === SENT_TO_FINANCIER || e === CONTRACT_SIGNED) > -1 ? true : false
    let leadLost = leadDetail?.basic_details?.refinance_status ? leadDetail?.basic_details?.refinance_status === LOST_STATUS.toString() : false;
    let user_page_access = IS_USER_ACCESS_PAGE("refinanceLoanDetail", "ucrf-customer-personal-details")?.is_edit_access
    let user_edit_access = CHECK_ASSIGN_USER(leadDetail.assigned_to)
    let nextEnable = leadDetail?.customer_timeline_status_ids?.length && leadDetail.customer_timeline_status_ids.findIndex(e => e === CUSTOMER_PERSONAL_DETAIL_FILLED) > -1 ? true : false
    if (!user_edit_access && user_page_access && !leadLost && !markAsFreezed) {
      setIsSaveDisabled(false)
      setIsNextEnabled(false)
    } else if (nextEnable) {
      setIsNextEnabled(true)
      setIsSaveDisabled(true)
    } else {
      setIsSaveDisabled(true)
      setIsNextEnabled(false)
    }
    if (!markAsFreezed && !user_edit_access && user_page_access) {
      setIsRemarkDisabled(false)
    }
  }

  return (
    <div className="image-form-outer" >
      {isLoading ? <Loader /> : ''}
      <div className="image-tab-panel">
        <DocumentGallery documentCategoryList={documentCategoryList} />
      </div>
      <div className="form-tab-right-panel">
        <div className="lead-detail-from-outer">
          <div className="lead-form-heading">
            <span className="main-heading">Customer Details</span>
            <h2>Personal Details</h2>
          </div>
          <Formsy
            className="lead-form-filed"
            autoComplete="off"
            onValid={() => setAllowSubmit(true)}
            onInvalid={() => setAllowSubmit(false)}
            onValidSubmit={handleSubmit}
            aria-label="lead form field personal detail"
          >
            <div className="row">
              <fieldset class="form-filed col-md-6 ">
                <FormsyInputField
                  id="customer_alternative_mobile_no"
                  name="customer_alternative_mobile_no"
                  type="mobile"
                  value={personalDetails?.["customer_alternative_mobile_no"] || ""}
                  placeholder=" "
                  label="Customer Alternative Mobile No"
                  onChange={(data) => handlePatternFormatChange(data, "customer_alternative_mobile_no")}
                  format={"+63 ### ### ######"}
                  validations={"isValidPhoneNumber"}
                  validationError="Enter Valid Customer Alternative Mobile No"
                  readOnly={isSaveDisable}
                  required={false}
                  showAsterisk={false}
                />
              </fieldset>

              <fieldset class="form-filed col-md-6 ">
                <FormsyInputField
                  id="customer_email_id"
                  name="customer_email_id"
                  type="text"
                  value={personalDetails?.["customer_email_id"] || ""}
                  placeholder=" "
                  label={"Customer Email ID"}
                  onChange={handleInputChange}
                  validationError="Enter Valid Customer Email ID"
                  validations={"isEmail"}
                  readOnly={(isSaveDisable) ? true : false}
                  required={false}
                  showAsterisk={false}
                />
              </fieldset>

              <fieldset class="single-select col-md-6">
                <FormsySelect
                  name={"customer_civil_status"}
                  id={"customer_civil_status"}
                  inputProps={{
                    options: ALL_OPTIONS && ALL_OPTIONS["customer_civil_status"],
                    placeholder: "Customer Civil Status",
                    className: "react-select",
                    classNamePrefix: "react-select",
                    value: ALL_OPTIONS && ALL_OPTIONS["customer_civil_status"] && ALL_OPTIONS["customer_civil_status"].filter(({ value }) => value === personalDetails["customer_civil_status"]?.toString()),
                    isDisabled: (isSaveDisable)
                  }}
                  required={false}
                  showAsterisk={false}
                  value={personalDetails && personalDetails["customer_civil_status"]}
                  onChange={(data) => handleSelectChange(data, "customer_civil_status")}
                />
              </fieldset>

              <fieldset class="single-select col-md-6">
                <FormsySelect
                  name={"customer_type"}
                  id={"customer_type"}
                  inputProps={{
                    options: ALL_OPTIONS && ALL_OPTIONS["customer_type"],
                    placeholder: "Customer Type",
                    className: "react-select",
                    classNamePrefix: "react-select",
                    value: ALL_OPTIONS && ALL_OPTIONS["customer_type"] && ALL_OPTIONS["customer_type"].filter(({ value }) => value === personalDetails["customer_type"]?.toString()),
                    isDisabled: (isSaveDisable)
                  }}
                  required={true}
                  showAsterisk={true}
                  value={personalDetails && personalDetails["customer_type"]}
                  onChange={(data) => handleSelectChange(data, "customer_type")}
                />
              </fieldset>

              <fieldset class="single-select col-md-6">
                <FormsySelect
                  name={"customer_educational_attainment"}
                  id={"customer_educational_attainment"}
                  inputProps={{
                    options: ALL_OPTIONS?.["customer_educational_attainment"],
                    placeholder: "Customer Educational Attainment",
                    className: "react-select",
                    classNamePrefix: "react-select",
                    value: ALL_OPTIONS?.["customer_educational_attainment"] && ALL_OPTIONS?.["customer_educational_attainment"].filter(({ value }) => value === personalDetails["customer_educational_attainment"]?.toString()),
                    isDisabled: (isSaveDisable)
                  }}
                  required={false}
                  showAsterisk={false}
                  value={personalDetails && personalDetails["customer_educational_attainment"]}
                  onChange={(data) => handleSelectChange(data, "customer_educational_attainment")}
                />
              </fieldset>

              <fieldset class="form-filed col-md-6 ">
                <FormsyInputField
                  id="customer_mother_name"
                  name="customer_mother_name"
                  type="tb"
                  value={personalDetails?.["customer_mother_name"] || ""}
                  placeholder=" "
                  label={"Customer Mother's Name"}
                  onChange={handleInputChange}
                  validationError="Enter Valid Customer Mother's Name"
                  readOnly={(isSaveDisable) ? true : false}
                  required={false}
                  showAsterisk={false}
                />
              </fieldset>

              <fieldset class="form-filed col-md-6 ">
                <FormsyInputField
                  id="customer_father_name"
                  name="customer_father_name"
                  type="tb"
                  value={personalDetails?.["customer_father_name"] || ""}
                  placeholder=" "
                  label={"Customer Father's Name"}
                  onChange={handleInputChange}
                  validationError="Enter Valid Customer Father's Name"
                  readOnly={(isSaveDisable) ? true : false}
                  required={false}
                  showAsterisk={false}
                />
              </fieldset>

              <fieldset class="single-select col-md-6">
                <FormsySelect
                  name={"customer_gender"}
                  id={"customer_gender"}
                  inputProps={{
                    options: ALL_OPTIONS && ALL_OPTIONS["customer_gender"],
                    placeholder: "Customer Gender",
                    className: "react-select",
                    classNamePrefix: "react-select",
                    value: ALL_OPTIONS && ALL_OPTIONS["customer_gender"] && ALL_OPTIONS["customer_gender"].filter(({ value }) => value === personalDetails["customer_gender"]?.toString()),
                    isDisabled: (isSaveDisable)
                  }}
                  required={true}
                  showAsterisk={true}
                  value={personalDetails && personalDetails["customer_gender"]}
                  onChange={(data) => handleSelectChange(data, "customer_gender")}
                />
              </fieldset>

              <fieldset class="single-select col-md-6">
                <FormsySelect
                  name={"customer_number_of_dependents"}
                  id={"customer_number_of_dependents"}
                  inputProps={{
                    options: ALL_OPTIONS?.["customer_number_of_dependents"],
                    placeholder: "Customer Number of Dependents",
                    className: "react-select",
                    classNamePrefix: "react-select",
                    value: ALL_OPTIONS?.["customer_number_of_dependents"] && ALL_OPTIONS?.["customer_number_of_dependents"].filter(({ value }) => value === personalDetails["customer_number_of_dependents"]?.toString()),
                    isDisabled: (isSaveDisable)
                  }}
                  required={false}
                  showAsterisk={false}
                  value={personalDetails && personalDetails["customer_number_of_dependents"]}
                  onChange={(data) => handleSelectChange(data, "customer_number_of_dependents")}
                />
              </fieldset>
            </div>

            <div className="btn-save-remarks">
              {(!allowSubmit || isSaveDisable) ?
                <>{isNextEnable ?
                  <button type="button" className="btn-primary" onClick={() => navigateToNext()}>Next</button>
                  :
                  <span className="span-disabled">
                    Save
                  </span>
                }
                </>
                :
                <button aria-label="save naxt" type="submit" className="btn-primary">
                  Save & Next
                </button>
              }
              <button aria-label="remarks history" type="button" className="btn-line"
                onClick={showModalViewTimeLine}
              >
                Remarks
                <span className="m-xs-l">({remarksHistory && (remarksHistory.length || 0)})</span>
              </button>
            </div>
          </Formsy>
        </div>
      </div>
      <div className="view-timeline-popup">
        <Modal show={ViewTimeLine} handleClose={hideModalViewTimeLine} >
          <div className="modal-header">
            <h2>Remark History</h2>
          </div>
          <LeadRemarkHistory showremarkform={showremarkform} markAsFreezed={false}
            isRemarkDisable={isRemarkDisable} sectionInfo={sectionInfo} />
        </Modal>
      </div>
    </div>
  );
}
export default RefinancePersonalDetailsForm;